import { CreateProjectTeamAssignmentDomainValidationFailureReasonEnum } from "../types/teamAssignment";

const projectTeamAssignmentBlockerReason = (blocker: CreateProjectTeamAssignmentDomainValidationFailureReasonEnum): string => {
    switch (blocker) {
        case CreateProjectTeamAssignmentDomainValidationFailureReasonEnum.Indeterminate: return "Indeterminate validation failure";
        case CreateProjectTeamAssignmentDomainValidationFailureReasonEnum.ProjectNotFound: return "Project not found";
        case CreateProjectTeamAssignmentDomainValidationFailureReasonEnum.AuthenticatedUserDoesNotHavePermission: return "You do not have permission to add this user";
        case CreateProjectTeamAssignmentDomainValidationFailureReasonEnum.ContactEmailDomainDoesNotMatchProjectDomain: return "Invalid email domain, does not match project domain";
        case CreateProjectTeamAssignmentDomainValidationFailureReasonEnum.InFlightProjectAdminAssignments: return "Admin assignment already in progress";  
        case CreateProjectTeamAssignmentDomainValidationFailureReasonEnum.DomainNotFound: return "Domain not found";
        default: return "Unknown error occurred";
    }
};

export {
    projectTeamAssignmentBlockerReason
};
